import React from "react";
import { Box, TextField, InputAdornment } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Search as SearchIcon, Close as CloseIcon } from "@mui/icons-material";
import getTrans from "../../../../../languages/getTrans";

const SearchInput = ({ value = "", onChange, onClear }) => {
	const classes = useStyles();
	return (
		<Box className={classes.searchContainer}>
			<TextField
				fullWidth
				value={value}
				onChange={onChange}
				placeholder={getTrans('services.Поиск по сервисам')}
				variant="outlined"
				className={classes.searchInput}
				InputProps={{
					startAdornment: (
						<InputAdornment position="start">
							<SearchIcon sx={{ fontSize: 24, color: "rgba(255,255,255,0.3)" }} />
						</InputAdornment>
					),
					endAdornment: value && (
						<InputAdornment position="end">
							<CloseIcon 
								sx={{ fontSize: 20, color: "rgba(255,255,255,0.3)", cursor: "pointer" }} 
								onClick={onClear}
							/>
						</InputAdornment>
					),
					className: classes.inputBase,
				}}
			/>
		</Box>
	);
};

const useStyles = makeStyles((theme) => ({
	searchContainer: {
		padding: "0 12px 12px 12px",
		boxSizing: "border-box",
		flexShrink: 0,
	},
	searchInput: {
		"& .MuiOutlinedInput-root": {
			height: "48px",
			borderRadius: "12px",
			background: "#FFFFFF0D",
			border: "1px solid #FFFFFF1A",
			"& fieldset": {
				border: "none",
			},
			"&:hover fieldset": {
				border: "none",
			},
			"&.Mui-focused fieldset": {
				border: "none",
			},
		},
		"& .MuiOutlinedInput-input": {
			padding: "0 12px",
			fontSize: 18,
			color: theme.palette.text.primary,
			"&::placeholder": {
				opacity: 0.3,
				color: theme.palette.text.primary,
			},
		},
	},
	inputBase: {
		"& input": {
			"&::placeholder": {
				opacity: 0.3,
			},
		},
	},
}));

export default SearchInput;
